import Button from 'react-bootstrap/Button'
import { ButtonLoader } from '../loader'

export default function SaveButton(props) {

    const { button_name, spinner } = props

    return (
        <>
            <Button type='submit' size='sm' className='submit_btn' disabled={spinner}>
                {spinner ?
                    <ButtonLoader />
                    :
                    button_name
                }
            </Button>
        </>
    )
}
